import { type SupportedLocale, supportedLocale } from './intl-types';

export function isLocaleSupported(locale: string): locale is SupportedLocale {
  return supportedLocale.includes(locale as SupportedLocale);
}
